<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Omnia Theme</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTabName">
        <el-tab-pane name="general" label="General">
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="createForm.name" placeholder="Name">
                <template slot="prefix">Name</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <dads-select
                v-model="createForm.partnerId"
                placeholder="Select partner account"
              >
                <template slot="prefix">Partner</template>
                <el-option
                  v-for="(partner, index) in partnerOptions"
                  :label="partner.name"
                  :key="index"
                  :value="partner.id"
                />
              </dads-select>
            </el-col>
          </div>

          <h2 class="form-section-header">
            Omnia application urls
          </h2>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="createForm.appDomain" placeholder="App url">
                <template slot="prefix">App url</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="createForm.meetDomain"
                placeholder="Meet domain"
              >
                <template slot="prefix">Meet domain</template>
              </el-input>
            </el-col>
          </div>
          <el-input
            v-model="createForm.quickDialUrl"
            placeholder="Quick dial extension url"
          >
            <template slot="prefix">Quick dial extension url</template>
          </el-input>

          <h2 class="form-section-header">
            Mobile application
          </h2>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input
                v-model="createForm.csName"
                placeholder="Mobile app identifier"
              >
                <template slot="prefix">Mobile app identifier</template>
              </el-input>
            </el-col>
          </div>
          <el-input v-model="createForm.iosUrl" placeholder="IOS app url">
            <template slot="prefix">IOS app url</template>
          </el-input>
          <el-input
            v-model="createForm.androidUrl"
            placeholder="Android app url"
          >
            <template slot="prefix">Android app url</template>
          </el-input>

          <h2 class="form-section-header">
            Support details
          </h2>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="createForm.supportUrl"
                placeholder="Support website url"
              >
                <template slot="prefix">Support website url</template>
              </el-input>
            </el-col>
            <el-col :span="1"/>
            <el-col :span="11">
              <el-input
                v-model="createForm.supportEmail"
                placeholder="Support email"
              >
                <template slot="prefix">Support email</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="createForm.changelogURL"
                placeholder="Change log url"
              >
                <template slot="prefix">Change log url</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input v-model="createForm.website" placeholder="Company website url">
                <template slot="prefix">Company website url</template>
              </el-input>
            </el-col>
          </div>

          <h2 class="form-section-header">
            Emails and social
          </h2>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="createForm.infoEmail" placeholder="Info email">
                <template slot="prefix">Info email</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="createForm.senderEmail"
                placeholder="Sender email"
              >
                <template slot="prefix">Sender email</template>
              </el-input>
            </el-col>
          </div>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                v-model="createForm.meetSenderEmail"
                placeholder="Meet Sender email"
              >
                <template slot="prefix">Meet Sender email</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="createForm.twitterHandle"
                placeholder="Twitter handle"
              >
                <template slot="prefix">Twitter handle</template>
              </el-input>
            </el-col>
          </div>
        </el-tab-pane>
        <el-tab-pane name="images" label="Images">
          <omnia-image-uploader
            title="App logo url (light mode)"
            :file="appLogoLightFile"
            @onUpload="appLogoLightFile = $event"
            @clearUpload="appLogoLightFile = null"
          />
          <omnia-image-uploader
            title="App logo url (dark mode)"
            :file="appLogoDarkFile"
            @onUpload="appLogoDarkFile = $event"
            @clearUpload="appLogoDarkFile = null"
          />
          <omnia-image-uploader
            title="Logo icon"
            :file="logoIconFile"
            @onUpload="logoIconFile = $event"
            @clearUpload="logoIconFile = null"
          />
          <omnia-image-uploader
            title="Favicon"
            :file="faviconFile"
            @onUpload="faviconFile = $event"
            @clearUpload="faviconFile = null"
          />
          <omnia-image-uploader
            title="Preview image"
            :file="previewImageFile"
            @onUpload="previewImageFile = $event"
            @clearUpload="previewImageFile = null"
          />
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import omniaImageUploader from "./omniaImageUploader.vue";
import DadsSelect from '@/components/select';

export default {
  name: "OmniaThemeCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    partnerOptions: { required: true }
  },

  components: { omniaImageUploader, DadsSelect },

  data() {
    return {
      activeTabName: "general",
      createForm: {
        name: "",
        appDomain: "",
        meetDomain: "",
        supportUrl: "",
        infoEmail: "",
        supportEmail: "",
        senderEmail: "",
        website: "",
        iosUrl: "",
        androidUrl: "",
        themeFolder: "",
        twitterHandle: "",
        quickDialUrl: "",
        csName: "",
        changelogURL: "",
        partnerId: "",
        meetSenderEmail: ""
      },
      // ⭐️ Image Uploads ⭐️ //
      imageFileNames: [
        "appLogoLightFile",
        "appLogoDarkFile",
        "logoIconFile",
        "faviconFile",
        "previewImageFile"
      ],
      appLogoLightFile: null,
      appLogoDarkFile: null,
      logoIconFile: null,
      faviconFile: null,
      previewImageFile: null
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    createOperation() {
      const formData = new FormData();
      Object.keys(this.createForm).forEach(key => {
        formData.append(key, this.createForm[key]);
      });

      this.imageFileNames.forEach(fileName => {
        if (this[fileName]) {
          formData.append(fileName.replace("File", ""), this[fileName].raw);
        }
      });

      this.$emit("createOperation", formData);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.activeTabName = "general";
      this.appLogoLightFile = null;
      this.appLogoDarkFile = null;
      this.logoIconFile = null;
      this.faviconFile = null;
      this.previewImageFile = null;
      Object.keys(this.createForm).forEach(key => {
        this.createForm[key] = "";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tabs {
  max-width: 600px;
  margin: 0 auto;
}
</style>
